/* FT GUYS - header logo reveal: COORDINATE READOUT.

   The mark parts and a monospaced readout scrambles through kana and digits
   before resolving. It holds, then the mark closes over it.

   THE READOUT NAMES WHERE YOU ARE. Liquid hands the page context in via
   window.FT_READ (see snippets/ft-logo-boot.liquid):
     home        PARALLEL UNIVERSE / 4471   - a random coordinate
     collection  PARALLEL UNIVERSE / JUSTICE
     product     PARALLEL UNIVERSE / HEAVY JUSTICE TEE
     cart, search, 404 and so on likewise
   That turns an ornament into a wayfinding cue: it says something true about the
   page instead of decorating every page identically.

   THE SECOND LINE IS FITTED, NOT TRUNCATED TO A GUESS. Monospace means width is
   arithmetic - characters x (size x 0.6 + tracking) - so the script solves for the
   largest type size that fits the gap, and only clips if the name is still too
   long at the floor size. A fixed character limit would cut JUSTICE needlessly and
   still overflow on a long product title.

   CENTRING IS MEASURED ON THREE AXES. The logo PNG has transparent padding, so the
   image box centre is not the mark's centre. The canvas scan returns the band
   between monogram and wordmark plus the ink centre on both axes, and the split,
   the parting and the readout all key off those.
*/
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ACCENT = '#ff5c1a';
  var INK = '#f5efe8';

  var PART = 900;
  var SCRAM = 1250;
  var HOLD = 900;
  var CLOSE = 950;
  var FADE = 420;
  var DIST = 56;               // each half; 2 x DIST is the usable gap
  var LABEL = 'PARALLEL UNIVERSE';

  var GLYPHS = '\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E9\u30EA\u30EB\u30EC\u30ED\u30F3' +
               '0123456789';

  function supportsMask() {
    return CSS.supports('mask-image', 'url(a.png)') ||
           CSS.supports('-webkit-mask-image', 'url(a.png)');
  }

  function measureLogo(url, cb) {
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onerror = function () { cb(null); };
    im.onload = function () {
      try {
        var w = Math.min(240, im.naturalWidth) || 0;
        if (!w) { cb(null); return; }
        var h = Math.max(1, Math.round(im.naturalHeight * (w / im.naturalWidth)));
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(im, 0, 0, w, h);
        var d = ctx.getImageData(0, 0, w, h).data;

        var rows = new Array(h), top = -1, bot = -1;
        for (var y = 0; y < h; y++) {
          var n = 0;
          for (var x = 0; x < w; x++) if (d[(y * w + x) * 4 + 3] > 16) n++;
          rows[y] = n;
          if (n > 0) { if (top < 0) top = y; bot = y; }
        }
        if (top < 0 || bot <= top) { cb(null); return; }

        var floor = top + (bot - top) * 0.45;
        var best = null, run = null;
        for (y = top; y <= bot; y++) {
          if (rows[y] === 0) { if (run === null) run = y; }
          else if (run !== null) {
            if (run > floor && (!best || (y - run) > best.len)) best = { start: run, len: y - run };
            run = null;
          }
        }
        var bandY = best ? best.start : bot + 1;

        var minX = w, maxX = -1, minY = h, maxY = -1;
        for (y = top; y < bandY; y++) {
          for (var x2 = 0; x2 < w; x2++) {
            if (d[(y * w + x2) * 4 + 3] > 16) {
              if (x2 < minX) minX = x2;
              if (x2 > maxX) maxX = x2;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
            }
          }
        }
        if (maxX < 0) { cb(null); return; }

        cb({
          band: best ? (best.start / h) : null,
          cx: ((minX + maxX + 1) / 2) / w,
          cy: ((minY + maxY + 1) / 2) / h
        });
      } catch (e) { cb(null); }
    };
    im.src = url;
  }

  function injectCSS(m) {
    var band = m.band === null ? 100 : +(m.band * 100).toFixed(2);
    var s = document.createElement('style');
    s.textContent =
      ':root{' +
        '--ft-logo-split:' + (+(m.cx * 100).toFixed(2)) + '%;' +
        '--ft-logo-mid:' + (+(m.cy * 100).toFixed(2)) + '%;' +
        '--ft-mono-h:' + band + '%;' +
      '}' +
      '.ft-logo{position:relative;display:inline-block;line-height:0;}' +
      '.ft-logo__base{transition:opacity ' + FADE + 'ms ease;}' +
      '.ft-logo.is-performing.has-band .ft-logo__base{clip-path:inset(var(--ft-mono-h) 0 0 0);}' +
      '.ft-logo.is-performing:not(.has-band) .ft-logo__base{opacity:0;}' +

      '.ft-logo__half{position:absolute;inset:0;z-index:3;pointer-events:none;' +
        'background-color:' + INK + ';' +
        '-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;' +
        '-webkit-mask-size:100% 100%;mask-size:100% 100%;' +
        '-webkit-mask-position:center;mask-position:center;' +
        'will-change:transform;' +
        'transition:transform ' + CLOSE + 'ms cubic-bezier(.16,1,.3,1),opacity ' + FADE + 'ms ease;}' +
      '.ft-logo__half--l{clip-path:polygon(0 0,var(--ft-logo-split) 0,var(--ft-logo-split) var(--ft-mono-h),0 var(--ft-mono-h));}' +
      '.ft-logo__half--r{clip-path:polygon(var(--ft-logo-split) 0,100% 0,100% var(--ft-mono-h),var(--ft-logo-split) var(--ft-mono-h));}' +
      '.ft-logo.is-parted .ft-logo__half{transition-duration:' + PART + 'ms;transition-timing-function:cubic-bezier(.22,.85,.24,1);}' +
      '.ft-logo.is-parted .ft-logo__half--l{transform:translate3d(-' + DIST + 'px,0,0);}' +
      '.ft-logo.is-parted .ft-logo__half--r{transform:translate3d(' + DIST + 'px,0,0);}' +
      '.ft-logo__half.is-done{opacity:0;}' +

      '.ft-read{position:absolute;left:var(--ft-logo-split);top:var(--ft-logo-mid);z-index:2;' +
        'transform:translate(-50%,-50%);pointer-events:none;white-space:nowrap;text-align:center;' +
        'font-family:ui-monospace,SFMono-Regular,"SF Mono",Menlo,Consolas,monospace;' +
        'opacity:0;transition:opacity 420ms ease;}' +
      '.ft-logo.is-parted .ft-read{opacity:1;}' +
      '.ft-logo.is-closing .ft-read{opacity:0;}' +
      '.ft-read__label{display:block;color:' + ACCENT + ';line-height:1.15;}' +
      '.ft-read__code{display:block;color:' + INK + ';line-height:1.2;opacity:.9;margin-top:3px;}' +
      '.ft-read__label.is-hot{color:' + INK + ';}';
    document.head.appendChild(s);
  }

  /* Monospace width is arithmetic, so solve for the largest size that fits
     rather than guessing a character limit. */
  function fit(el, text, maxWidth, sizes, tracking) {
    for (var i = 0; i < sizes.length; i++) {
      var per = sizes[i] * 0.6 + sizes[i] * tracking;
      if (text.length * per <= maxWidth) {
        el.style.fontSize = sizes[i] + 'px';
        el.style.letterSpacing = tracking + 'em';
        el.style.textIndent = (tracking / 2) + 'em';
        return text;
      }
    }
    // still too long at the smallest size - clip to what actually fits
    var small = sizes[sizes.length - 1];
    var perSmall = small * 0.6 + small * tracking;
    el.style.fontSize = small + 'px';
    el.style.letterSpacing = tracking + 'em';
    el.style.textIndent = (tracking / 2) + 'em';
    return text.slice(0, Math.max(3, Math.floor(maxWidth / perSmall) - 1));
  }

  function pick(str) { return str.charAt(Math.floor(Math.random() * str.length)); }

  function scramble(el, target, duration, onDone) {
    var q = [];
    for (var i = 0; i < target.length; i++) {
      var start = Math.floor(Math.random() * 16);
      q.push({ to: target[i], start: start, end: start + 12 + Math.floor(Math.random() * 18), ch: '' });
    }
    var frame = 0, total = 0;
    q.forEach(function (c) { if (c.end > total) total = c.end; });
    var perFrame = duration / Math.max(1, total);
    var last = performance.now();

    (function tick(now) {
      if (now - last >= perFrame) {
        last = now;
        frame++;
        var out = '', done = 0;
        for (var i = 0; i < q.length; i++) {
          var c = q[i];
          if (c.to === ' ') { out += ' '; done++; continue; }
          if (frame >= c.end) { out += c.to; done++; }
          else if (frame >= c.start) {
            if (!c.ch || Math.random() < 0.3) c.ch = pick(GLYPHS);
            out += c.ch;
          } else out += ' ';
        }
        el.textContent = out;
        if (done === q.length) { if (onDone) onDone(); return; }
      }
      requestAnimationFrame(tick);
    })(performance.now());
  }

  function readout() {
    var wrap = document.createElement('span');
    wrap.className = 'ft-read';
    wrap.setAttribute('aria-hidden', 'true');

    var label = document.createElement('span');
    label.className = 'ft-read__label';
    var code = document.createElement('span');
    code.className = 'ft-read__code';
    wrap.appendChild(label);
    wrap.appendChild(code);

    var gap = DIST * 2 - 10;   // a little breathing room either side
    var ctx = (window.FT_READ && window.FT_READ.ctx) || '';
    // no context (home) - a live coordinate instead
    var second = ctx || String(Math.floor(Math.random() * 9000) + 1000);

    var labelText = fit(label, LABEL, gap, [7, 6.4, 5.8, 5.2], 0.16);
    var codeText = fit(code, second, gap, [10, 9, 8, 7, 6.2], ctx ? 0.14 : 0.2);

    wrap._play = function () {
      scramble(label, labelText, SCRAM, function () {
        label.classList.add('is-hot');
        setTimeout(function () { label.classList.remove('is-hot'); }, 110);
      });
      scramble(code, codeText, SCRAM * 0.85);
    };
    return wrap;
  }

  function half(cls, url) {
    var e = document.createElement('span');
    e.className = 'ft-logo__half ' + cls;
    e.setAttribute('aria-hidden', 'true');
    e.style.webkitMaskImage = 'url("' + url + '")';
    e.style.maskImage = 'url("' + url + '")';
    return e;
  }

  function start(img, m) {
    var url = img.currentSrc || img.src;
    if (!url || !supportsMask()) return;

    if (!m) m = { band: null, cx: 0.5, cy: 0.5 };
    var hasBand = m.band !== null && m.band > 0.5 && m.band < 0.97;
    if (!hasBand) m.band = null;
    injectCSS(m);

    var wrap = document.createElement('span');
    wrap.className = 'ft-logo is-performing';
    if (hasBand) wrap.classList.add('has-band');
    img.parentNode.insertBefore(wrap, img);
    wrap.appendChild(img);
    img.classList.add('ft-logo__base');

    var read = readout();
    var l = half('ft-logo__half--l', url);
    var r = half('ft-logo__half--r', url);
    wrap.appendChild(read);
    wrap.appendChild(l);
    wrap.appendChild(r);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        wrap.classList.add('is-parted');
        setTimeout(read._play, Math.round(PART * 0.4));

        setTimeout(function () {
          wrap.classList.remove('is-parted');
          wrap.classList.add('is-closing');

          setTimeout(function () {
            wrap.classList.remove('is-performing');
            l.classList.add('is-done');
            r.classList.add('is-done');
            setTimeout(function () {
              l.remove(); r.remove(); read.remove();
            }, FADE + 120);
          }, CLOSE);
        }, PART + SCRAM + HOLD);
      });
    });
  }

  function begin(img) {
    var url = img.currentSrc || img.src;
    if (!url) return;
    measureLogo(url, function (m) { start(img, m); });
  }

  function init() {
    var group = document.getElementById('header-group');
    if (!group) return;

    var img = group.querySelector('.header-logo__image-container--original .header-logo__image')
           || group.querySelector('.header-logo__image')
           || group.querySelector('a[href="/"] img')
           || group.querySelector('img');
    if (!img || img.dataset.ftLogoSplit) return;
    img.dataset.ftLogoSplit = '1';

    if (img.complete && img.naturalWidth) begin(img);
    else img.addEventListener('load', function () { begin(img); }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
